import merge from 'lodash/merge';

/**
 * Browser global `window.B2BCabinetUI`: defaults from this bundle.
 *
 * @typedef {object} B2BCabinetUiRuntime
 * @property {string} language
 * @property {{ load: string }} events
 * @property {{
 *   [key: string]: { [key: string]: [value: unknown]}
 * }} components
 */

const B2BCABINET_UI_LOAD_EVENT = 'B2BCabinetUILoaded';
const DEFAULT_CONFIG = {
    language: 'en',
    events: {
        load: B2BCABINET_UI_LOAD_EVENT,
    },
    components: {
        calendar: {
            format: 'DD.MM.YYYY',
            lang: 'auto',
        },
    },
};

export function initDefaultConfig() {
    if (typeof window === 'undefined') {
        return;
    }

    if(typeof window.B2BCabinetUI !== 'undefined') {
        window.B2BCabinetUI = merge({}, DEFAULT_CONFIG, window.B2BCabinetUI);
    } else {
        window.B2BCabinetUI = DEFAULT_CONFIG;
    }
}

/**
 * @returns {B2BCabinetUiRuntime|undefined}
 */
export function getConfig() {
    if (typeof window === 'undefined') {
        return undefined;
    }
    return window.B2BCabinetUI;
}

/**
 * @returns {{ format: string, lang: string }|undefined}
 */
export function getComponentConfig(componentName) {
    return getConfig()?.components?.[componentName];
}

/**
 * @returns {string}
 */
export function getLanguage() {
    return getConfig()?.language ?? 'en';
}
